import {
  CITY_FILTER_DATA1,
  BUILDING_FILTER_DATA1,
  BUILDING_DATA1,
  SET_USER_ACCESS,
  SET_USER,
  SET_ERRORS,
  CLEAR_ERRORS,
  LOADING_UI,
  SET_UNAUTHENTICATED,
  MEMBER_LIST,
  NEW_MEMBER_DATA,
  LOADER_CHECK,
  CITY_FILTER_DATA,
  BUILDING_FILTER_DATA,
  MEMBER_LIST_EDIT,
  SET_EDIT_USER_LIST,
  EXPORT_FILE,
  LIST_UPDATE,
  BUILK_FILE_UPLOAD,
  BUILDING_DATA,
  BUILDING_SPOC_DATA,
} from '../type';

import axios from 'axios';
import { toast } from 'react-toastify';
import { spocMemberList, getSPOCLocation } from '../../Component/Helpers/api';
import {
  aditionalmember,
  cityUrl,
  buildingUrl,
  spocEdit,
  spocEditForm,
  exportFile,
  addMemberUrl,
  bulkFile,
  bulkFile2,
  userAccessDetails,
} from '../../Component/Helpers/api';

import $ from 'jquery';
import mixpanel from 'mixpanel-browser';
import { dataUser } from '../../Component/Helpers/util';
import axiosInstance from '../../utils/axiosInstance';

const userDataLocal = dataUser();
var UserObj = JSON.parse(userDataLocal);
// export const fetchHome = async (data) => {

//   let bodyFormData = new FormData();
//   bodyFormData.append('location', data.pincode)
//   bodyFormData.append('token', data.token);
//   const res = await axios.post(`${API_URL}/home`, bodyFormData)
//   return res
//   }

export const grantAccess = params => async dispatch => {
  try {
    // Retrieve organization data from localStorage
    const organizationData = JSON.parse(localStorage.getItem('headData'));

    if (!organizationData) {
      throw new Error('Organization data not found in localStorage.');
    }

    // Extract `rec_id` (user ID) from params
    const { rec_id } = params; // Ensure `rec_id` is part of the params

    if (!rec_id) {
      throw new Error('rec_id is missing in the request params.');
    }

    // Make the API call
    const res = await axiosInstance.put(
      `${process.env.REACT_APP_API_GATEWAYS_URL
      }cspoc/api/v2/user/access/${rec_id}`, // Use `rec_id` in URL
      { active: true }, // Payload (matches your curl request)
      {
        headers: {
          // Use the token from localStorage
          'req-organization-id': organizationData.organizationId,
          'req-organization-type': organizationData.roomShared,
          // Ensure Content-Type header
        },
      },
    );

    // Handle success
    if (res.status === 200) {
      toast.success('Access granted successfully.', {});

      // Dispatch success action
      dispatch({
        type: SET_USER_ACCESS,
        payload: res,
      });

      // Optional: Reload page or perform any UI updates
      setTimeout(() => {
        window.location.reload();
      }, 1000);

      // Close modal if needed
    } else {
      // Handle API errors
      toast.error(res.data.data.message || 'Failed to grant access.', {});
    }
  } catch (error) {
    console.error('Error granting access:', error);

    // Handle errors and show a toast
    const errorMessage =
      error.response?.data?.data?.error ||
      error.response?.data?.message ||
      'An unexpected error occurred. Please try again.';

    toast.error(errorMessage);

    dispatch({ type: CLEAR_ERRORS }); // Clear errors if any
  }
};

export const grantAccess1 = params => async dispatch => {
  try {
    // Retrieve organization data from localStorage
    const organizationData = JSON.parse(localStorage.getItem('headData'));

    if (!organizationData) {
      throw new Error('Organization data not found in localStorage.');
    }

    // Extract `rec_id` (user ID) from params
    const { rec_id } = params; // Ensure `rec_id` is part of the params

    if (!rec_id) {
      throw new Error('rec_id is missing in the request params.');
    }

    // Make the API call
    const res = await axiosInstance.put(
      `${process.env.REACT_APP_API_GATEWAYS_URL
      }cspoc/api/v2/user/access/${rec_id}`, // Use `rec_id` in URL
      { active: false }, // Payload (matches your curl request)
      {
        headers: {
          // Use the token from localStorage
          'req-organization-id': organizationData.organizationId,
          'req-organization-type': organizationData.roomShared,
          // Ensure Content-Type header
        },
      },
    );

    // Handle success
    if (res.status === 200) {
      toast.success('Revoke Access successfully', {});

      // Dispatch success action
      dispatch({
        type: SET_USER_ACCESS,
        payload: res,
      });

      // Optional: Reload page or perform any UI updates
      setTimeout(() => {
        window.location.reload();
      }, 1000);

      // Close modal if needed
    } else {
      // Handle API errors
      toast.error(res.data.data.message, {});
    }
  } catch (error) {
    console.error('Error granting access:', error);

    // Handle errors and show a toast
    const errorMessage =
      error.response?.data?.data?.error ||
      error.response?.data?.message ||
      'An unexpected error occurred. Please try again.';

    toast.error(errorMessage);

    dispatch({ type: CLEAR_ERRORS }); // Clear errors if any
  }
};

export const allMember = pageDetail => dispatch => {
  let authToken = JSON.parse(localStorage.getItem('headData'));
  dispatch({ type: LOADING_UI });
  axios
    .post(spocMemberList.memberList, pageDetail, {
      headers: {
        Authorization: authToken?.spintlyToken,
      },
    })

    .then(res => {
      if (res.status === 200) {
        dispatch({ type: MEMBER_LIST, payload: res.data.data });
        dispatch({ type: CLEAR_ERRORS });
        dispatch({ type: LOADER_CHECK });
      } else {
        dispatch({ type: CLEAR_ERRORS });
        toast.error(res.data.message, {});
        dispatch({ type: CLEAR_ERRORS });
      }
    })
    .catch(error => {
      dispatch({ type: CLEAR_ERRORS });
    });
};

export const exportFileFunc = pageDetail => dispatch => {
  let authToken = JSON.parse(localStorage.getItem('headData'));
  dispatch({ type: LOADING_UI });
  axios
    .post(exportFile.memberList, pageDetail, {
      headers: {
        Authorization: authToken?.spintlyToken,
      },
    })
    .then(res => {
      if (res.status === 200) {
        dispatch({ type: EXPORT_FILE, payload: res.data.data });
        dispatch({ type: CLEAR_ERRORS });
        dispatch({ type: LOADER_CHECK });
        $('.close').click();
        // toast.success(res.data.message, {
        //
        // });
      } else {
        dispatch({ type: CLEAR_ERRORS });
        toast.error(res.data.message, {});
        dispatch({ type: CLEAR_ERRORS });
      }
    })
    .catch(error => {
      dispatch({ type: CLEAR_ERRORS });
    });
};

// Maps a backend "scenario" message to a user-friendly notification message.
// Falls back to a generic message for anything unrecognised.
const ADD_MEMBER_GENERIC_ERROR =
  'Something went wrong. Please try again later or contact support if the issue continues.';

const getAddMemberErrorMessage = rawMessage => {
  const msg = (rawMessage || '').toLowerCase();

  // Email already registered
  if (msg.includes('email') && msg.includes('core db')) {
    return 'This email ID is already registered. Please use a different email address.';
  }
  if (
    msg.includes('email') &&
    (msg.includes('keycloak') || msg.includes('auth db'))
  ) {
    return 'This email ID already exists in the system. Kindly try with another email address.';
  }

  // Lookups not found
  if (msg.includes('organization') && msg.includes('not found')) {
    return 'We could not find the selected organization. Please check the Organization ID and try again.';
  }
  if (msg.includes('property') && msg.includes('not found')) {
    return 'We could not find the selected property. Please verify the Property ID and try again.';
  }

  // Creation failures
  if (msg.includes('keycloak')) {
    return 'Unable to create the user at the moment. Please try again after some time.';
  }
  if (msg.includes('old db')) {
    return 'User creation could not be completed due to a system issue. Please try again later.';
  }
  if (msg.includes('core db')) {
    return 'We were unable to save the user details. Kindly retry after some time.';
  }

  // Generic / Unexpected error
  return ADD_MEMBER_GENERIC_ERROR;
};

export const AddMember = stateData => async dispatch => {
  try {
    const organizationData = JSON.parse(localStorage.getItem('headData'));

    dispatch({ type: LOADING_UI });

    const res = await axiosInstance.post(
      `${process.env.REACT_APP_API_GATEWAYS_URL}cspoc/api/v2/user/`,
      stateData,
      {
        headers: {
          'req-organization-id': organizationData.organizationId,
          'req-organization-type': organizationData.roomShared,
        },
      }
    );

    dispatch({ type: CLEAR_ERRORS });

    if (res.status >= 200 && res.status < 300) {
      dispatch({ type: LIST_UPDATE, payload: res });
      dispatch({ type: SET_USER, payload: res.data.data });

      return {
        success: true,
        message: res.data.message || 'Member added successfully!',
      };
    }

    return {
      success: false,
      message: getAddMemberErrorMessage(res.data?.message),
    };
  } catch (error) {
    dispatch({ type: CLEAR_ERRORS });

    const rawMessage =
      error.response?.data?.data?.error || error.response?.data?.message;

    return {
      success: false,
      message: getAddMemberErrorMessage(rawMessage),
    };
  }
};



export const ActiveListsetEdit = pageDetail => async dispatch => {
  let authToken = JSON.parse(localStorage.getItem('headData'));
  // dispatch({ type: LOADING_UI });

  try {
    const res = await axiosInstance.post(
      `${process.env.REACT_APP_API_GATEWAYS_URL}cspoc/api/v2/user/user_details`,
      pageDetail,
      {},
    );

    if (res.status === 200) {
      dispatch({ type: MEMBER_LIST_EDIT, payload: { ...res.data.data, _editTimestamp: Date.now() } });
      dispatch({ type: CLEAR_ERRORS });
      // dispatch({ type: LOADER_CHECK });

      const params = { cityid: res.data.data.city_id };
      const buildingRes = await axios.post(
        `${process.env.REACT_APP_API_URL}user/building`,
        params,
        {
          headers: {
            Authorization: authToken?.spintlyToken,
          },
        },
      );

      dispatch({ type: BUILDING_DATA, payload: buildingRes.data.data });
      dispatch({ type: CLEAR_ERRORS });
      // dispatch({ type: LOADER_CHECK });

      const floorParams = { buildingid: res.data.data.location_id };
      const floorRes = await axios.post(
        `${process.env.REACT_APP_API_URL}user/floor`,
        floorParams,
        {
          headers: {
            Authorization: authToken?.spintlyToken,
          },
        },
      );

      dispatch({
        type: BUILDING_FILTER_DATA,
        payload: floorRes.data.data,
      });

      dispatch({ type: CLEAR_ERRORS });
    } else {
      dispatch({ type: CLEAR_ERRORS });
    }
  } catch (error) {
    dispatch({ type: CLEAR_ERRORS });
  }
};

export const memberAditionData = cliend_id => dispatch => {
  const localDaata = JSON.parse(localStorage.getItem('headData'));
  dispatch({ type: LOADING_UI });
  let authToken = JSON.parse(localStorage.getItem('headData'));
  axios
    .get(
      `${process.env.REACT_APP_API_URL}basic-data/get-city-by-client?client=${localDaata?.company_id
      }`,
      {
        headers: {
          Authorization: authToken?.spintlyToken,
        },
      },
    )
    .then(res => {
      if (res.status === 200) {
        dispatch({ type: NEW_MEMBER_DATA, payload: res.data.data });

        dispatch({ type: CLEAR_ERRORS });
      } else {
        dispatch({ type: CLEAR_ERRORS });
      }
    })

    .catch(error => {
      dispatch({ type: CLEAR_ERRORS });
    });
};

export const onCityLocation1 = params => dispatch => {
  let authToken = JSON.parse(localStorage.getItem('headData'));
  // dispatch({ type: LOADING_UI });
  axios
    .post(
      `${process.env.REACT_APP_API_URL}basic-data/get-city-by-spoc`,
      params,
      {
        headers: {
          Authorization: authToken?.spintlyToken,
        },
      },
    )
    .then(res => {
      if (res.status === 200) {
        dispatch({ type: CITY_FILTER_DATA1, payload: res.data.data });
        // dispatch({ type: NEW_MEMBER_DATA, payload: res.data.data });
        dispatch({ type: CLEAR_ERRORS });
        dispatch({ type: BUILDING_DATA1, payload: res.data.data });
      } else {
        dispatch({ type: CLEAR_ERRORS });
      }
    })
    .catch(error => {
      dispatch({ type: CLEAR_ERRORS });
    });
};

export const onCityLocation = params => dispatch => {
  let authToken = JSON.parse(localStorage.getItem('headData'));
  // dispatch({ type: LOADING_UI });
  axios
    .get(
      `${process.env.REACT_APP_API_URL}basic-data/get-location?city=${params.cityid
      }&client=${202}`,
      {
        headers: {
          Authorization: authToken?.spintlyToken,
        },
      },
    )
    .then(res => {
      if (res.status === 200) {
        dispatch({ type: CITY_FILTER_DATA, payload: res.data.data });

        dispatch({ type: CLEAR_ERRORS });

        dispatch({ type: BUILDING_DATA, payload: res.data.data });
      } else {
        dispatch({ type: CLEAR_ERRORS });
      }
    })

    .catch(error => {
      dispatch({ type: CLEAR_ERRORS });
    });
};

export const onBuildingLocation1 = params => dispatch => {
  let authToken = JSON.parse(localStorage.getItem('headData'));
  // dispatch({ type: LOADING_UI });

  axios
    .get(
      `${process.env.REACT_APP_API_URL}basic-data/get-loc-by-city-n-spoc?city=${params?.city
      }&spoc=${params?.spoc}&client=${params.client}`,
      {
        headers: {
          Authorization: authToken?.spintlyToken,
        },
      },
    )
    .then(res => {
      if (res.status === 200) {
        dispatch({ type: BUILDING_FILTER_DATA1, payload: res.data.data });
        dispatch({ type: CITY_FILTER_DATA, payload: res.data.data });
        dispatch({ type: CLEAR_ERRORS });
      } else {
        dispatch({ type: CLEAR_ERRORS });
      }
    })
    .catch(error => {
      dispatch({ type: CLEAR_ERRORS });
    });
};

export const onBuildingLocation = params => dispatch => {
  let authToken = JSON.parse(localStorage.getItem('headData'));
  // dispatch({ type: LOADING_UI });
  axios
    .post(buildingUrl.data, params, {
      headers: {
        Authorization: authToken?.spintlyToken,
      },
    })
    .then(res => {
      if (res.status === 200) {
        dispatch({ type: BUILDING_FILTER_DATA, payload: res.data.data });
        dispatch({ type: CLEAR_ERRORS });
      } else {
        dispatch({ type: CLEAR_ERRORS });
      }
    })
    .catch(error => {
      dispatch({ type: CLEAR_ERRORS });
    });
};

export const editformMember = (params) => async (dispatch) => {
  try {
    // Retrieve organization data from localStorage
    const organizationData = JSON.parse(localStorage.getItem("headData"));

    if (!organizationData) {
      throw new Error("Organization data not found in localStorage.");
    }

    // Dispatch loading action
    dispatch({ type: LOADING_UI });

    // Ensure `rec_id` is present in params
    const { rec_id } = params;
    if (!rec_id) {
      throw new Error("rec_id is missing in the request parameters.");
    }

    // Make the API call
    const res = await axiosInstance.put(
      `${process.env.REACT_APP_API_GATEWAYS_URL}cspoc/api/v2/user/${rec_id}`,
      params, // `params` contains only updated fields
      {
        headers: {
          "req-organization-id": organizationData.organizationId,
          "req-organization-type": organizationData.roomShared,

        },
      }
    );

    if (res.status === 200) {
      toast.success(res.data.message || "Member updated successfully!");

      // Dispatch success action
      dispatch({ type: SET_EDIT_USER_LIST, payload: res });

      // Close modal (if applicable)
      $(".close").click();

      // Reload page after a short delay
      setTimeout(() => {
        window.location.reload();
      }, 500);
    } else {
      // ✅ Handle non-successful responses
      toast.error(res.data.message || "Something went wrong!");
      dispatch({ type: CLEAR_ERRORS });
    }
  } catch (error) {
    console.error("Error editing member:", error);

    // ✅ Extract error message safely
    const errorMessage =
      error.response?.data?.data?.error ||
      error.response?.data?.message ||
      "An unexpected error occurred. Please try again.";

    toast.error(errorMessage);

    // Dispatch error actions
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_ERRORS, payload: [] });
  }
};

// export const addBulkUploadFile = (pageDetail, param) => dispatch => {
//   dispatch({ type: LOADING_UI });
//   axios
//     .post(
//       `${bulkFile.data}?company_id=${pageDetail?.company_id}&added_by=${1}`,
//       param,
//     )
//     .then(res => {
//
//       if (res.status === 200) {
//         if (res.data.invalidData.length > 0) {
//           res.data.invalidData.map(item => {
//             toast.configure();
//             toast.error(`${item}`, {
//
//             });
//           });
//           // toast.configure();
//           // toast.error(
//           //   'The first name, last name, phone no, Dob or email id in some of the entries is invalid',
//           //   {
//           //
//           //   },
//           // );
//           dispatch({ type: CLEAR_ERRORS });
//         }
//         // if (res.data.invalidInsert.length > 0) {
//         //   res.data.invalidInsert.map(item => {
//         //     toast.configure();
//         //     toast.error(`${item.msg} for ${item.fname} ${item.lname}`, {
//         //
//         //     });
//         //   });
//         //   dispatch({ type: CLEAR_ERRORS });
//         // }
//         if (res.data.validUpdate.length > 0) {
//           res.data.validUpdate.map(item => {
//             toast.configure();
//             toast.success(
//               `Data updated Successfully for ${item.fname} ${item.lname}`,
//               {
//
//               },
//             );
//           });
//           // dispatch({
//           //   type: BUILK_FILE_UPLOAD,
//           //   payload: res,
//           // });
//         }
//         if (
//           res.data.validInsert.length > 0 ||
//           res.data.validUpdate.length > 0
//         ) {
//           res.data.validInsert.map(item => {
//             toast.configure();
//             toast.success(
//               `Data Added Successfully for ${item.fname} ${item.lname}`,
//               {
//
//               },
//             );
//           });
//           dispatch({
//             type: BUILK_FILE_UPLOAD,
//             payload: res,
//           });
//           $('.close').click();
//         }
//         if (
//           res.data.invalidData.length == 0 &&
//           res.data.invalidInsert.length == 0 &&
//           res.data.validInsert.length == 0 &&
//           res.data.validUpdate.length == 0
//         ) {
//           toast.configure();
//           toast.success(`Nothing To Update`, {
//
//           });
//           $('.close').click();
//         }
//       } else {
//         toast.configure();
//         toast.error(res.data.message, {
//
//         });
//         dispatch({ type: CLEAR_ERRORS });
//       }
//     })
//     .catch(error => {
//       dispatch({ type: CLEAR_ERRORS });
//     });
// };

export const addBulkUploadFile = formData => async dispatch => {
  dispatch({ type: LOADING_UI });

  try {
    const organizationData = JSON.parse(localStorage.getItem('headData'));
    if (!organizationData) throw new Error('Organization data not found.');

    const response = await axiosInstance.post(
      `${process.env.REACT_APP_API_GATEWAYS_URL}cspoc/api/v2/user/bulk`,
      formData,
      {
        headers: {
          'req-organization-id': organizationData.organizationId,
          'Content-Type': 'multipart/form-data',
        },
      },
    );

    if (response.status === 200) {
      dispatch({ type: BUILK_FILE_UPLOAD, payload: response });
      dispatch({ type: LOADER_CHECK });
      dispatch({ type: CLEAR_ERRORS });

      toast.success(
        response.data.data || 'File uploaded successfully. Members imported.',
        { autoClose: 5000, pauseOnHover: true },
      );

      mixpanel.track('Import Member Successfully', {
        PageName: 'Members',
        UserEmail: UserObj.email,
        UserName: `${UserObj.fname} ${UserObj.lname}`,
        UserId: UserObj.rec_id,
        CompanyId: UserObj.company_id,
        CompanyName: UserObj.company_name,
        Type: 'Members',
      });

      return { success: true, data: response.data };
    }
    throw new Error(response.data.message || 'Upload failed');
  } catch (error) {
    if (error.response?.status === 400 && error.response.data?.errors) {
      dispatch({ type: LOADER_CHECK });
      dispatch({ type: CLEAR_ERRORS });
      return {
        success: false,
        validationErrors: error.response.data.errors,
      };
    }

    const message =
      error?.response?.data?.message || error.message || 'Unknown error';
    toast.error(`Upload failed: ${message}`, {
      autoClose: 10000,
      pauseOnHover: true,
    });
    dispatch({ type: LOADER_CHECK });
    dispatch({ type: CLEAR_ERRORS });
    return { success: false, error: error.response?.data };
  }
};

export const addBulkUploadFile2 = (pageDetail, param, callback) => dispatch => {
  let authToken = JSON.parse(localStorage.getItem('headData'));
  dispatch({ type: LOADING_UI });
  axios
    .post(
      `${bulkFile2.data}?company_id=${pageDetail?.company_id
      }&added_by=${1}&overwrite_opt=${pageDetail?.overwrite_opt}&floor_id=${pageDetail?.floor_id
      }`,
      param,
      {
        headers: {
          Authorization: authToken?.spintlyToken,
        },
      },
    )
    .then(res => {
      if (res.data.validUpdateCount > 0) {
        // toast.configure();
        toast.success(
          `${res.data.validUpdateCount} Record updated in the system`,
          {},
        );
        // dispatch({ type: CLEAR_ERRORS });
      }
      if (res.data.validInsertCount > 0) {
        // toast.configure();
        toast.success(
          `${res.data.validInsertCount} Record added in the system`,
          {},
        );
        // dispatch({ type: CLEAR_ERRORS });
      }
      if (res.data.nothingToUpdate > 0) {
        // toast.configure();
        toast.success(
          `${res.data.nothingToUpdate} Record unchanged in the system`,
          {},
        );
        // dispatch({ type: CLEAR_ERRORS });
      }
      if (res.data.duplicatePhone.length > 0) {
        res.data.duplicatePhone.map(item => {
          // toast.configure();
          toast.success(`${item}`, {
            // autoClose: false,
            // closeButton: CloseToastButton,
          });
        });
        // dispatch({ type: CLEAR_ERRORS });
      }
      mixpanel.track('Import Member Successfully', {
        PageName: 'Members',
        UserEmail: UserObj.email,
        UserName: UserObj.fname + ' ' + UserObj.lname,
        UserId: UserObj.rec_id,
        CompanyId: UserObj.company_id,
        CompanyName: UserObj.company_name,
        Type: 'Members',
      });
      callback();
    })
    .catch(error => {
      dispatch({ type: CLEAR_ERRORS });
    });
};

export const onSPOCLocation = params => dispatch => {
  let authToken = JSON.parse(localStorage.getItem('headData'));
  // dispatch({ type: LOADING_UI });
  axios
    .get(`${getSPOCLocation.data}`, {
      params, // Correctly pass the params object here
      headers: {
        Authorization: `${authToken?.spintlyToken}`,
      },
    })
    .then(res => {
      if (res.status === 200) {
        dispatch({ type: BUILDING_SPOC_DATA, payload: res.data.data });
        dispatch({ type: CLEAR_ERRORS });
      } else {
        dispatch({ type: CLEAR_ERRORS });
      }
    })
    .catch(error => {
      dispatch({ type: CLEAR_ERRORS });
    });
};
